import { Component } from '@mycolorway/tao';

Component('tr-set-channel', {
  properties: {
    channel: {
      type: String,
    },
  },

  ready() {
    document.querySelector(`#nav-${this.channel}`).classList.add('active');
  },
});
